import { render, staticRenderFns } from "./widget-editor-test-indicator.vue?vue&type=template&id=50a5fbab&scoped=true&"
import script from "./widget-editor-test-indicator.vue?vue&type=script&lang=js&"
export * from "./widget-editor-test-indicator.vue?vue&type=script&lang=js&"
import style0 from "./widget-editor-test-indicator.vue?vue&type=style&index=0&id=50a5fbab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a5fbab",
  null
  
)

export default component.exports